import { render, staticRenderFns } from "./AdmissionForm.vue?vue&type=template&id=2bf3db64&scoped=true&"
import script from "./AdmissionForm.vue?vue&type=script&lang=js&"
export * from "./AdmissionForm.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionForm.vue?vue&type=style&index=0&id=2bf3db64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf3db64",
  null
  
)

export default component.exports